/** The release actually executing in this document, not merely a build-time claim. */
export function currentPwaRelease(): string {
  if (typeof document === "undefined") return "development";
  const script = Array.from(document.scripts)
    .map((item) => item.src)
    .find((value) => /\/assets\/index-[^/]+\.js$/.test(value));
  return script
    ? new URL(script).pathname.split("/").pop() ?? "development"
    : "development";
}
